import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.066 5h6.843C19.512 5 20 5.488 20 6.09v2.82A1.09 1.09 0 0 1 18.91 10H5.3l6.093-4.768A1.1 1.1 0 0 1 12.066 5M10.16 3.657A3.1 3.1 0 0 1 12.066 3h6.843A3.09 3.09 0 0 1 22 6.09v10.82c0 2.258-1.832 4.09-4.09 4.09H6.09A4.09 4.09 0 0 1 2 16.91V15.27a1 1 0 1 1 2 0v1.638A2.09 2.09 0 0 0 6.09 19h11.82A2.09 2.09 0 0 0 20 16.91v-5.108c-.34.128-.707.198-1.09.198H3.85c-1.425 0-2.047-1.802-.924-2.681zM14 14a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_window-kH9ntpfX.js.map
